import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthProvider';
import { getEvalRun, listEvalRuns } from './client';
import { keys } from './keys';

/**
 * Recent eval run headers, newest first (ADR-0072, `evals:read`). `enabled`
 * waits on `/me`, so a caller without the grant never fires a request that
 * would only 403 (and land in the error sink as noise).
 */
export function useEvalRuns(enabled: boolean) {
  const { getAccessToken } = useAuth();
  return useQuery({
    queryKey: keys.evals.runs(),
    queryFn: ({ signal }) => listEvalRuns({ getAccessToken, signal }),
    enabled,
  });
}

/** One run's case results. Disabled until a run is selected. A run is immutable once published. */
export function useEvalRun(runId: string | undefined, enabled: boolean) {
  const { getAccessToken } = useAuth();
  return useQuery({
    queryKey: keys.evals.run(runId ?? ''),
    queryFn: ({ signal }) => getEvalRun(runId ?? '', { getAccessToken, signal }),
    enabled: enabled && runId !== undefined,
    staleTime: Infinity,
  });
}
